export default __webpack_public_path__ + "static/media/image-danche.42b87a74.png";